import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Skeleton } from "antd";
import moment from "moment";

import orderApi from "../../../apis/Order.api";
import ApiService from "../../../utils/ApiService";

const api = new ApiService();

const DashboardSales = () => {
	const user = useSelector((state) => state.auth.user);
	const [loading, setLoading] = useState(false);

	const [statistics, setStatistics] = useState({
		last_month: 0,
		last_month_num: 0,
		month: 0,
		yesterday: 0,
		yesterday_num: 0,
		today: 0,
		today_num: 0,
		total_price: 0,
		purchases_num: 0,
	});

	useEffect(() => {
		if (user?.id) {
			const timer = setTimeout(() => {
				getStatistics();
			}, 100);
			return () => clearTimeout(timer);
		}
	}, [user]);

	const getStatistics = useCallback(async () => {
		setLoading(true);
		const param = {
			userId: user?.id,
		};
		const res = await api.getProductLinkList(param);
		if (res.data.code === 200 && res.data.result?.length) {
			const linkList = res.data.result.map((link) => link.query);
			const query = linkList.join(",");

			const paramLastMonth = {
				startDate: moment()
					.subtract(1, "months")
					.startOf("months")
					.format("YYYYMMDDHHmm"),
				endDate: moment()
					.subtract(1, "months")
					.endOf("months")
					.format("YYYYMMDDHHmm"),
				queryList: query,
			};
			const paramMonth = {
				startDate: moment().startOf("months").format("YYYYMMDDHHmm"),
				endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
				queryList: query,
			};
			const paramYesterday = {
				startDate: moment()
					.subtract(1, "days")
					.startOf("days")
					.format("YYYYMMDDHHmm"),
				endDate: moment()
					.subtract(1, "days")
					.endOf("days")
					.format("YYYYMMDDHHmm"),
				queryList: query,
			};
			const paramDay = {
				startDate: moment().startOf("days").format("YYYYMMDDHHmm"),
				endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
				queryList: query,
			};

			const rspLM = await orderApi.orderStatistics(paramLastMonth);
			const rspM = await orderApi.orderStatistics(paramMonth);
			const rspY = await orderApi.orderStatistics(paramYesterday);
			const rspD = await orderApi.orderStatistics(paramDay);

			let returnData = { ...statistics };
			if (rspLM.code === 200) {
				returnData = {
					...returnData,
					last_month: rspLM.result?.expected_profit_amount ?? 0,
					last_month_num: rspLM.result?.purchases_num ?? 0,
				};
			} else {
				returnData = {
					...returnData,
					last_month: 0,
					last_month_num: 0,
				};
			}
			if (rspM.code === 200) {
				returnData = {
					...returnData,
					total_price: rspM.result?.total_purchase_amount ?? 0,
					purchases_num: rspM.result?.purchases_num ?? 0,
					month: rspM.result?.expected_profit_amount ?? 0,
				};
			} else {
				returnData = {
					...returnData,
					total_price: 0,
					purchases_num: 0,
					month: 0,
				};
			}
			if (rspY.code === 200) {
				returnData = {
					...returnData,
					yesterday: rspY.result?.expected_profit_amount ?? 0,
					yesterday_num: rspY.result?.purchases_num ?? 0,
				};
			} else {
				returnData = {
					...returnData,
					yesterday: 0,
					yesterday_num: 0,
				};
			}
			if (rspD.code === 200) {
				returnData = {
					...returnData,
					today: rspD.result?.expected_profit_amount ?? 0,
					today_num: rspD.result?.purchases_num ?? 0,
				};
			} else {
				returnData = {
					...returnData,
					today: 0,
					today_num: 0,
				};
			}
			setStatistics(returnData);
		} else {
			setStatistics({
				last_month: 0,
				last_month_num: 0,
				month: 0,
				yesterday: 0,
				yesterday_num: 0,
				today: 0,
				today_num: 0,
				total_price: 0,
				purchases_num: 0,
			});
		}
		setLoading(false);
	}, []);

	return (
		<div className={`dashboard-body-each`}>
			<h2 className={`dashboard-each-title`}>판매 실적</h2>

			<div style={{ display: "flex", gap: "3em" }}>
				<div className={`dashboard-huge-number-div`} style={{ flexGrow: 1 }}>
					<Skeleton
						loading={loading}
						active={loading}
						size={"large"}
						block={true}
						style={{
							height: "6em",
						}}
						paragraph={{
							rows: 3,
							width: "100%",
						}}
					>
						<p>금일 예상 수익</p>
						<div
							style={{
								display: "flex",
								alignItems: "end",
								gap: "2px",
								marginBottom: "5px",
							}}
						>
							<h3>{statistics?.today?.toLocaleString()}</h3>
							<p>원</p>
						</div>
						<div className={`compare-price-div`}>
							<p className={`gray`}>어제 대비</p>
							{statistics?.today_num - statistics?.yesterday_num > 0 ? (
								<p className={`orange`}>
									{(
										statistics?.today_num - statistics?.yesterday_num
									).toLocaleString()}
									건 증가
								</p>
							) : (
								<p className={`orange`}>
									{Math.abs(
										statistics?.today_num - statistics?.yesterday_num
									).toLocaleString()}
									건 감소
								</p>
							)}
						</div>
						<div className={`compare-price-div`}>
							<p className={`gray`}>어제 대비</p>
							{statistics?.today - statistics?.yesterday > 0 ? (
								<p className={`orange`}>
									{(statistics?.today - statistics?.yesterday).toLocaleString()}
									원 증가
								</p>
							) : (
								<p className={`orange`}>
									{Math.abs(
										statistics?.today - statistics?.yesterday
									).toLocaleString()}
									원 감소
								</p>
							)}
						</div>
					</Skeleton>
				</div>
				<div className={`dashboard-huge-number-div`} style={{ flexGrow: 1 }}>
					<Skeleton
						loading={loading}
						active={loading}
						size={"large"}
						block={true}
						style={{
							height: "6em",
						}}
						paragraph={{
							rows: 3,
							width: "100%",
						}}
					>
						<p>이번달 예상 수익</p>
						<div
							style={{
								display: "flex",
								alignItems: "end",
								gap: "2px",
								marginBottom: "5px",
							}}
						>
							<h3>{statistics?.month?.toLocaleString()}</h3>
							<p>원</p>
						</div>
						<div className={`compare-price-div`}>
							<p className={`gray`}>지난달 대비</p>
							{statistics?.purchases_num - statistics?.last_month_num > 0 ? (
								<p className={`orange`}>
									{(
										statistics?.purchases_num - statistics?.last_month_num
									).toLocaleString()}
									건 증가
								</p>
							) : (
								<p className={`orange`}>
									{Math.abs(
										statistics?.purchases_num - statistics?.last_month_num
									).toLocaleString()}
									건 감소
								</p>
							)}
						</div>
						<div className={`compare-price-div`}>
							<p className={`gray`}>지난달 대비</p>
							{statistics?.month - statistics?.last_month > 0 ? (
								<p className={`orange`}>
									{(
										statistics?.month - statistics?.last_month
									).toLocaleString()}
									원 증가
								</p>
							) : (
								<p className={`orange`}>
									{Math.abs(
										statistics?.month - statistics?.last_month
									).toLocaleString()}
									원 감소
								</p>
							)}
						</div>
					</Skeleton>
				</div>
			</div>

			<div className={`dashboard-each-data-div`}>
				<Skeleton
					loading={loading}
					active={loading}
					size={"large"}
					block={true}
					style={{
						height: "6em",
					}}
					paragraph={{
						rows: 3,
						width: "100%",
					}}
					title={false}
				>
					<div className={`dashboard-data-each`}>
						<p>{moment().format("M")}월 구매 건수</p>
						<p>{statistics?.purchases_num?.toLocaleString()}</p>
					</div>
					<div className={`dashboard-data-each`}>
						<p>{moment().format("M")}월 구매 합산 금액</p>
						<p>{statistics?.total_price?.toLocaleString()}원</p>
					</div>
					<div className={`dashboard-data-each`}>
						<p>{moment().format("M")}월 예상 수익</p>
						<p>{statistics?.month?.toLocaleString()}원</p>
					</div>
				</Skeleton>
			</div>
			<Link to={"/reports"}>판매 리포트로 이동</Link>
		</div>
	);
};

export default DashboardSales;
